<template>
  <div class="preview-container">
    <div class="preview-body">
      <iframe v-if="viewerUrl" :src="viewerUrl" class="preview-iframe"></iframe>
      <van-empty v-else description="Invalid file link" />
      <div class="wm-overlay-in-viewer" :style="wmStyle"></div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, onUnmounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
const route = useRoute()
const router = useRouter()
const src = computed(() => String(route.query.src || ''))
const viewerUrl = computed(() =>
  src.value
    ? `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(src.value)}`
    : '',
)
const ret = computed(() => String(route.query.return || ''))
const wm = computed(() => String(route.query.wm || ''))
const wmStyle = computed(() => {
  const text = wm.value
  const svg = `<svg xmlns='http://www.w3.org/2000/svg' width='260' height='260'><text x='30%' y='50%' dominant-baseline='middle' text-anchor='middle' fill='rgba(0,0,0,0.12)' font-size='12' font-family='system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif' transform='rotate(-30,130,130)'>${text}</text></svg>`
  const url = 'data:image/svg+xml;utf8,' + encodeURIComponent(svg)
  return { backgroundImage: `url("${url}")` }
})

let popHandler: ((e: PopStateEvent) => void) | null = null
onMounted(() => {
  if (!ret.value) return
  popHandler = () => {
    router.replace(ret.value)
  }
  window.addEventListener('popstate', popHandler)
  window.history.pushState({ officePreview: true }, '', location.href)
})
onUnmounted(() => {
  if (popHandler) window.removeEventListener('popstate', popHandler)
})
</script>

<style scoped>
.preview-container {
  height: 100vh;
  display: flex;
  flex-direction: column;
}
.preview-body {
  flex: 1;
  overflow: hidden;
  position: relative;
}
.preview-iframe {
  width: 100%;
  height: 100%;
  border: none;
}
.wm-overlay-in-viewer {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  z-index: 1;
  background-repeat: repeat;
  background-size: 260px 260px;
}
</style>
